'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _styles = require('../../WMTable/styles');

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	header: {
		display: 'table-row',
		height: '56px',
		fontSize: '12px'
	},

	checkbox: Object.assign({}, _styles2.default.cell, { paddingLeft: '24px' })
};


// WEBPACK FOOTER //
// ./~/@workmarket/front-end-components/dist/WMTableHeader/styles/index.js